import { io, Socket } from 'socket.io-client';
import { getSocketUrl } from '../config/apiConfig';
import { getCurrentToken } from '../utils/userStorage';
import { DashboardNotification } from './api';

export const connectDashboardNotificationSocket = (
  onNotification: (notification: DashboardNotification) => void
): (() => void) => {
  const token = getCurrentToken();
  if (!token) return () => undefined;

  const socket: Socket = io(getSocketUrl(), {
    auth: { token },
    transports: ['websocket', 'polling'],
    reconnection: true,
    reconnectionAttempts: 5
  });

  socket.on('connect', () => socket.emit('join-dashboard-notifications'));
  socket.on('dashboard-notification', onNotification);

  return () => {
    socket.off('dashboard-notification', onNotification);
    socket.disconnect();
  };
};
